// extracted by mini-css-extract-plugin
module.exports = {"heroFullCasper":"HeroFullCasper_heroFullCasper__4yOVD","sectionTitle":"HeroFullCasper_sectionTitle__QPPhw","desc":"HeroFullCasper_desc__nMwNR"};